import { render } from "./ProdPrice.vue?vue&type=template&id=a8d78ce4&scoped=true"
import script from "./ProdPrice.vue?vue&type=script&lang=js"
export * from "./ProdPrice.vue?vue&type=script&lang=js"

import "./ProdPrice.vue?vue&type=style&index=0&id=a8d78ce4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d78ce4"]])

export default __exports__